import React from "react";
import moment from "moment";
import { useLocaleContext } from "../../../../context/LocaleContext";
import { isStreamRecord } from "../../../../utils/stream";
import "./style.scss";

export default ({ stream }) => {
    const { get } = useLocaleContext();

    const timeNow = moment().unix();
    const hasNextEpisodes = stream?.episode.some(episode => episode.timeStop > timeNow);

    if (!hasNextEpisodes && isStreamRecord(stream)) {
        return null;
    }

    return (
        <div className="stream-player-overlay-interrupted">
            <div className="stream-player-overlay-interrupted-container">
                <h1>{get(`broadcast.overlay.${hasNextEpisodes ? 'interrupted' : 'stopped'}.title`)}</h1>
            </div>
        </div>
    )
}
